import keyCodes from '../../../../../../editJournal/constants/keyCodes';
import { isEnd } from './end';

export default (params) => {
  const { event, editor } = params;
  const {
    value: {
      focusBlock,
      selection: { isExpanded },
    },
  } = editor;

  if (focusBlock) {
    const { type: focusBlockType } = focusBlock;
    if (event.which === keyCodes.RIGHT_ARROW) {
      if (focusBlockType !== 'paragraph') {
        const isAtEndOfField = isEnd(editor);
        if (isAtEndOfField) {
          if (event.shiftKey) {
            event.preventDefault();
            return true;
          }
          if (isExpanded) {
            return false;
          }
          event.preventDefault();
          return true;
        }
      }
    }
  }

  return false;
};
